// Func = limiting Scope for this file
var lastScrollTop = 0;
(function() {

    $(document).ready(function() {

        //Call function with browser is resized.
        $(window).resize(function(event) {
            //resizeWindow();
        });
        //resizeWindow();

        //Acts when scroll down page.
        $(window).scroll(function(event) {
            //scrollDown();
        });

        // Main Nav Dropdown
        $(".mod-no-touchevents #primary-nav li").hover(function() {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function() {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        /*ANchor linnk to offer*/
        console.log($('.specials__text'))
    });

    // BOOKING TOGGLE
    document.querySelectorAll('.js-booking-toggle').forEach(btn => {
        btn.addEventListener('click', e => {
            let bookingModule = document.querySelector('#booking-overlay');
            e.preventDefault();
            bookingModule.classList.add('open');
        });
    });
    document.querySelectorAll('.js-bw-close').forEach(btn => {
        btn.addEventListener('click', e => {
            let bookingModule = document.querySelector('#booking-overlay');
            e.preventDefault();
            bookingModule.classList.remove('open');
        });
    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        //scrollDownAction(20, 'scroll');

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

$(".top-content-home__slider").slick({
    autoplay: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    autoplaySpeed: 7000,
    speed: 1000,
    pauseOnHover: false,
    lazyLoad: "ondemand"
});


$(".home-rooms__slider").slick({
    arrows: true,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 1000,
    pauseOnHover: false,
    lazyLoad: "ondemand",
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style="display: block;"><img src="./assets/images/arrow.svg" /></button>',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><img src="./assets/images/arrow.svg" /></button>',
});


//Custom dots home Rooms
$('.home-rooms__slider').on('init', function(event, slick, currentSlide, nextSlide) {    
    $('.home-rooms__slide').each(function() {
        $('.home-rooms__dots').append('<a href="javascript:;" class="home-rooms__dot">a</a>')
    }).promise().done(function() {
        $('.home-rooms__dot').on('click', function() {
            var indesxin = $(this).index();
            $('.home-rooms__slider').slick('slickGoTo', indesxin);
        });
        $('.home-rooms__dot').first().addClass('active');
    });
}).on('beforeChange', function(evn, slk, cur, nextSlide) {
    var nein = nextSlide + 1;
    $('.home-rooms__dot').removeClass('active');
    $('.home-rooms__dot:nth-child(' + nein + ')').addClass('active');
});


//Custom dots home Offers
$('.home-offers__slider').on('init', function(event, slick, currentSlide, nextSlide) {    
    $('.home-offers__item').each(function() {
        $('.home-offers__dots').append('<a href="javascript:;" class="home-offers__dot">a</a>')
    }).promise().done(function() {
        $('.home-offers__dot').on('click', function() {
            var indesxin = $(this).index();
            $('.home-offers__slider').slick('slickGoTo', indesxin);
        });
        $('.home-offers__dot').first().addClass('active');
    });
}).on('beforeChange', function(evn, slk, cur, nextSlide) {
    var nein = nextSlide + 1;
    $('.home-offers__dot').removeClass('active');
    $('.home-offers__dot:nth-child(' + nein + ')').addClass('active');
});


function getNodeindex(elm) {
    var c = elm.parentNode.children,
        i = 0;
    for (; i < c.length; i++)
        if (c[i] == elm) return i;
}

/* Accordion */
var accordionItems = document.querySelectorAll('.top-reasons__accordion-item');
var i;
for (i = 0; i < accordionItems.length; i++) {
    let disItem = accordionItems[i];
    let disBtn = disItem.querySelector('.top-reasons__accordion-title');
    disBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var tales = getNodeindex(disItem);
        if (document.querySelector('.top-reasons__bottom-img .slick-slider')) {
            $('.top-reasons__bottom-img .sym-slides').slick('slickGoTo', tales);
        }
        if (disItem.classList.contains('active')) {
            disItem.classList.remove('active');
        } else {
            accordionItems.forEach((obj) => {
                obj.classList.remove('active');
            })
            disItem.classList.add('active');
        }
    });
}

/* Menu Mobile */
var menuclose = document.querySelector('.header__nav__close-btn');
if (menuclose) {
    menuclose.addEventListener('click', function(e) {
        e.preventDefault();
        var menuObj = document.querySelector('.header__nav');
        menuObj.classList.add('close');
        menuObj.classList.remove('open');
    });
    document.querySelector('.hamburger__btn').addEventListener('click', function(e) {
        e.preventDefault();
        var menuObj = document.querySelector('.header__nav');
        menuObj.classList.add('open');
        menuObj.classList.remove('close');
    });
}